import { CheckStatus } from "../hooks/CheckStatus";

export const StatusMessage = ({status} : { status: CheckStatus}) => {

    if (status != CheckStatus.NoError && status != CheckStatus.Error) {
        return <></>
    }

    if (status === CheckStatus.Error) {
        return (<div className="menu error">S'ha produït un error en el servidor. Torneu-ho a provar més tard.</div>)
    }

    return (<div className="menu no-error">No s'ha trobat cap error!</div>)
}